import {CatalogMeta} from '@/src/(pages)/catalog/meta'

export {CatalogMeta}
